var _g, _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19353_242022)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0012,
    cy: 18.9993,
    r: 12.2727,
    fill: "#6C757D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5435 25.4753C17.9356 25.9125 18.4389 26.1526 18.9612 26.1526H18.9619C19.4865 26.1526 19.9921 25.9125 20.3849 25.4746C20.5953 25.242 20.954 25.223 21.1864 25.4329C21.4195 25.6428 21.4384 26.0026 21.2288 26.2352C20.6172 26.9148 19.8127 27.2891 18.9619 27.2891H18.9604C18.112 27.2883 17.3089 26.9141 16.6996 26.2345C16.49 26.0019 16.5089 25.642 16.742 25.4329C16.9751 25.2223 17.3339 25.2412 17.5435 25.4753ZM18.9989 11C22.3632 11 24.6232 13.6229 24.6232 16.0723C24.6232 17.3323 24.9434 17.8664 25.2832 18.4331C25.6193 18.9923 26 19.6272 26 20.8272C25.7358 23.8934 22.538 24.1434 18.9989 24.1434C15.4597 24.1434 12.2611 23.8934 12 20.8757C11.9977 19.6272 12.3785 18.9923 12.7145 18.4331L12.8331 18.2332C13.1253 17.7307 13.3745 17.1841 13.3745 16.0723C13.3745 13.6229 15.6345 11 18.9989 11ZM18.9989 12.1364C16.3536 12.1364 14.5098 14.2108 14.5098 16.0723C14.5098 17.6475 14.0731 18.3755 13.6871 19.018C13.3775 19.534 13.1331 19.9416 13.1331 20.8272C13.2595 22.2561 14.2018 23.007 18.9989 23.007C23.7695 23.007 24.7413 22.2228 24.867 20.778C24.8647 19.9416 24.6202 19.534 24.3106 19.018C23.9246 18.3755 23.4879 17.6475 23.4879 16.0723C23.4879 14.2108 21.6442 12.1364 18.9989 12.1364Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19353_242022",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19353_242022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19353_242022",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/reminder.c9b0306caa2a37a51ef39c51cbb19511.svg";
export { ForwardRef as ReactComponent };